// extracted by mini-css-extract-plugin
module.exports = {"history":"History_history__1cjgi"};